import React from 'react'
import LgyTooltip from 'app/components/util/lgy-tooltip/LgyTooltip'

const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max))

const LgyCheckbox = ({
  id,
  input,
  label,
  required,
  autoFocus,
  tooltip,
  checked,
  disabled,
  meta: { touched, error, warning, dirty }
}) => {
  const success = dirty && !error && !warning
  id = id || (input.name + getRandomInt(100000))
  return (
    <div className={touched && error ? 'usa-input-error lgy-checkbox' : 'lgy-checkbox'}>
      <input
        id={id}
        type='checkbox'
        className={success ? 'usa-input-success' : ''}
        checked={checked !== undefined ? checked : input.value}
        required={required}
        autoFocus={autoFocus}
        aria-describedby={error ? `${id}-error` : tooltip ? `${id}-tip` : ''}
        aria-invalid={touched && error}
        disabled={disabled}
        {...input} />
      <label htmlFor={id}>
        {label}
        {tooltip && <LgyTooltip message={tooltip} id={`${id}-tip`} />}
      </label>
      {touched && error && <span className='usa-input-error-message' id={`${id}-error`} role='alert'>{error}</span>}
      {touched && warning && (
        <span className='usa-input-error-message text-gold' role='alert'>
          {warning}
        </span>
      )}
    </div>
  )
}

export default LgyCheckbox